import React from 'react';
import { Flexer } from '../dashboard/elements/LayoutElements';

export const DevPage = () => {
    return <Flexer>Hello</Flexer>;
};
